import { render, staticRenderFns } from "./SessionTopicList.vue?vue&type=template&id=2e1eb670"
import script from "./SessionTopicList.vue?vue&type=script&lang=js"
export * from "./SessionTopicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports